import { getService as service } from '../util/angular_helpers.js';
import { addPageAction } from '../util/new_relic.js';

class LibrariesIndexPage extends HTMLElement {
  connectedCallback() {
    this.addEventListener('primary', this.handleCoachmarkClick);
    window.addEventListener('beforeunload', () => {
      const page = 'libraries';
      addPageAction(`typekit.${page}.page_exit`);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('primary', this.handleCoachmarkClick);
  }

  handleCoachmarkClick() {
    const UserPrefsService = service('UserPrefsService');
    UserPrefsService.updatePrefs({ hideLibrariesCoachmark: 'share-your-library' });
  }
}

customElements.define('af-libraries-index-page', LibrariesIndexPage);

export { LibrariesIndexPage };
